import { useRef, useEffect } from 'react';
import {
    Form,
    Row,
    Col,
    Card,
    Table,
    InputGroup,
    Image,
    Stack,
    Alert,
    CardBody,
} from 'react-bootstrap';
import { ADD, AXE, CYL, PD, SPH } from './options';
import EyeUpload from '../../Assets/Img/eye_upload.png';
import config from '../../Api/config';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import { FileText } from 'lucide-react';
import { getSecureItem } from "../../utils/secureStorage";
// Custom MenuList that scrolls to "0.00"
const CustomMenuList = (props) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollIntoView({ block: 'center' });
        }
    }, []);

    return (
        <components.MenuList {...props}>
            {props.children &&
                props.children.length > 0 &&
                props.children.map((child) => {
                    // Mark the "0.00" option with a ref
                    if (child?.props?.data?.value === '0.00') {
                        return (
                            <div ref={ref} key={child.key}>
                                {child}
                            </div>
                        );
                    }
                    return child;
                })}
        </components.MenuList>
    );
};
const Step3 = ({
    error,
    setAddEyeTestConfig,
    addEyeTestConfig,
    handleChange,
    imageHandle,
    glass,
    view,
    eyeTestImages = {},
    images = {},
}) => {
    const user = getSecureItem('UserData');
    const { t } = useTranslation();
    const changeOption = (value, name, orderNo) => {
        setAddEyeTestConfig((prev) => ({
            ...prev,
            testDetails: prev.testDetails.map((item) =>
                item.orderNo === orderNo
                    ? { ...item, [name]: value }
                    : { ...item }
            ),
        }));
    };
    const isEyeDoctor = user?.userType === 'EYEDOCTOR';
    const isPatient = user?.userType === 'PATIENT';
    const isAdminLike = ['ADMIN', 'BACKOFFICE', 'OPTICIAN'].includes(
        user?.userType
    );
    const isExternal = getSecureItem('ExternalOptician');
    // visibility
    const shouldShow =
        (isEyeDoctor && !!addEyeTestConfig?.testDetails.length) ||
        isPatient ||
        (isAdminLike &&
            ['Approved', 'Not Approved'].includes(addEyeTestConfig?.status));

    // editable?
    const canEdit =
        isEyeDoctor && addEyeTestConfig?.status?.toLowerCase() === 'new';

    useEffect(() => {
        console.log('eyeTestImages === ', eyeTestImages);
        console.log('images === ', images);
    }, [eyeTestImages, images]);

    const selectValue = (index, item) => {
        return addEyeTestConfig?.testDetails[index - 1][item];
    };

    const sameObjective = (e, target, copy) => {
        setAddEyeTestConfig((prev) => {
            const filterItems = prev.testDetails.filter(
                (item) => item.testType === copy
            );

            return {
                ...prev,
                testDetails: prev.testDetails.map((item) => {
                    if (item.testType === target) {
                        const matchingItem = filterItems.find(
                            (filterItem) =>
                                filterItem.whichEye === item.whichEye
                        );

                        if (matchingItem) {
                            const updatedValues = e.target.checked
                                ? {
                                    sph: matchingItem.sph,
                                    cyl: matchingItem.cyl,
                                    axe: matchingItem.axe,
                                    add: matchingItem.add,
                                    pd: matchingItem.pd,
                                }
                                : {
                                    sph: '0.00',
                                    cyl: '0.00',
                                    axe: '0.00',
                                    add: '0.00',
                                    pd: '0.00',
                                };

                            return {
                                ...item,
                                ...updatedValues,
                            };
                        }
                    }
                    return item;
                }),
            };
        });
    };

    return (
        <>
            <div>
                {user?.userType !== 'PATIENT' && (
                    <>

                        <Card
                            className={`${view == 'view'
                                ? 'custom_disabled mb-3 eye_test_symtoms'
                                : 'mb-3 eye_test_symtoms'
                                }`}
                        >
                            <Card.Body className="modal_form">
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('doesSubjectWearGlasses')}*
                                            </Form.Label>
                                            <Form.Select
                                                aria-label="Default"
                                                name="doYouWearGlasses"
                                                onChange={handleChange}
                                                value={
                                                    addEyeTestConfig.doYouWearGlasses
                                                }
                                                required
                                            >
                                                <option disabled value={''}>
                                                    {t('selectItem')}
                                                </option>
                                                <option value={true}>{t('yes')}</option>
                                                <option value={false}>{t('no')}</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('typeofVision')}</Form.Label>

                                            {view === 'view' ? (
                                                <Form.Control
                                                    type="text"
                                                    value={
                                                        addEyeTestConfig?.typeOfVision
                                                            ? t(
                                                                addEyeTestConfig.typeOfVision === 'Far Vision'
                                                                    ? 'farVision'
                                                                    : addEyeTestConfig.typeOfVision === 'Close Vision'
                                                                        ? 'closeVision'
                                                                        : 'progressiveVision'
                                                            )
                                                            : 'N/A'
                                                    }
                                                    readOnly
                                                />
                                            ) : (
                                                <Form.Select
                                                    aria-label="Default"
                                                    name="typeOfVision"
                                                    onChange={handleChange}
                                                    value={addEyeTestConfig?.typeOfVision || ''}
                                                >
                                                    <option value="">{t('selectItem')}</option>
                                                    <option value="Far Vision">{t('farVision')}</option>
                                                    <option value="Close Vision">{t('closeVision')}</option>
                                                    <option value="Progressive Vision">
                                                        {t('progressiveVision')}
                                                    </option>
                                                </Form.Select>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card
                            className={`${view == 'view'
                                ? 'custom_disabled mb-3 eye_test_symtoms'
                                : 'mb-3 eye_test_symtoms'
                                }`}
                        >
                            <Card.Body className="modal_form">
                                <Card.Title className="add_eye_title">
                                    <h4 className="mb-3">
                                        {t('correctionCarried')}
                                    </h4>
                                </Card.Title>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>SPH</th>
                                            <th>CYL</th>
                                            <th>AXE</th>
                                            <th>ADD</th>
                                            {glass == true && <th>PD</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>OD</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    defaultValue={SPH.find(
                                                        (option) =>
                                                            option.value ===
                                                            '0.00'
                                                    )}
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            1,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            1,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            1
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            1,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            1,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            1
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            1,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                1,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    1,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            1
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            1,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            1,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            1
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                1,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                1,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                1
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td>OG</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            2,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            2,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            2
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            2,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            2,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            2
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            2,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                2,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    2,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            2
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            2,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            2,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            2
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                2,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                2,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                2
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    </tbody>
                                </Table>
                                {/* {error?.testAufronto && (
                                    <Alert variant={'danger'}>
                                        {t(error?.testAufronto)}
                                    </Alert>
                                )} */}
                            </Card.Body>
                        </Card>
                        <Card
                            className={`${view == 'view'
                                ? 'custom_disabled mb-3 eye_test_symtoms'
                                : 'mb-3 eye_test_symtoms'
                                }`}
                        >
                            <Card.Body className="modal_form">
                                <Card.Title className="add_eye_title">
                                    <h4 className="mb-3">
                                        {t('objectiveRefraction')}*
                                    </h4>
                                </Card.Title>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>SPH</th>
                                            <th>CYL</th>
                                            <th>AXE</th>
                                            <th>ADD</th>
                                            {glass == true && <th>PD</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>OD</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            3,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            3,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            3
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            3,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            3,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            3
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            3,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                3,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    3,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            3
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            3,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            3,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            3
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                3,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                3,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                3
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td>OG</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            4,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            4,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            4
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            4,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            4,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            4
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            4,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                4,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    4,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            4
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            4,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            4,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            4
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                4,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                4,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                4
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    </tbody>
                                </Table>
                                {error?.auto_ref && (
                                    <Alert variant={'danger'}>
                                        {t(error?.auto_ref)}
                                    </Alert>
                                )}
                            </Card.Body>
                        </Card>
                        <Card
                            className={`${view == 'view'
                                ? 'custom_disabled mb-3 eye_test_symtoms'
                                : 'mb-3 eye_test_symtoms'
                                }`}
                        >
                            <Card.Body className="modal_form">
                                <Card.Title className="add_eye_title">
                                    <Stack
                                        direction="horizontal"
                                        gap={3}
                                        className="mb-3"
                                    >
                                        <h4 className="">
                                            {t('subjectiveRefraction')}*
                                        </h4>
                                        {/* {view !== 'view' ? (
                                            <Form.Check
                                                className="ms-auto"
                                                type="checkbox"
                                                id={`same_objective`}
                                                onChange={(e) =>
                                                    sameObjective(
                                                        e,
                                                        'Réfraction subjective (manuelle)',
                                                        'Auto ref'
                                                    )
                                                }
                                                label={t('copyValues')}
                                            />
                                        ) : (
                                            ''
                                        )} */}
                                    </Stack>
                                </Card.Title>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>SPH</th>
                                            <th>CYL</th>
                                            <th>AXE</th>
                                            <th>ADD</th>
                                            {glass == true && <th>PD</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>OD</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            5,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            5,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            5
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            5,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            5,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            5
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            5,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                5,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    5,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            5
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            5,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            5,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            5
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                5,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                5,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                5
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td>OG</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            6,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            6,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            6
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            6,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            6,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            6
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            6,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                6,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    6,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            6
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            6,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            6,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            6
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                6,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                6,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                6
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    </tbody>
                                </Table>
                                {error?.refraction && (
                                    <Alert variant={'danger'}>
                                        {t(error?.refraction)}
                                    </Alert>
                                )}
                            </Card.Body>
                        </Card>
                        <Card
                            className={`${view == 'view'
                                ? 'custom_disabled mb-3 eye_test_symtoms'
                                : 'mb-3 eye_test_symtoms'
                                }`}
                        >
                            <Card.Body className="modal_form">
                                <Card.Title className="add_eye_title">
                                    <Stack
                                        direction="horizontal"
                                        gap={3}
                                        className="mb-3"
                                    >
                                        <h4 className="">
                                            {t('finalOpticianRecommendation')}*
                                        </h4>
                                        {view !== 'view' ? (
                                            <Form.Check
                                                className="ms-auto"
                                                type="checkbox"
                                                id={`same_subjective`}
                                                onChange={(e) =>
                                                    sameObjective(
                                                        e,
                                                        'Reco opticien',
                                                        'Réfraction subjective (manuelle)'
                                                    )
                                                }
                                                label={t('copyValues')}
                                            />
                                        ) : (
                                            ''
                                        )}
                                    </Stack>
                                </Card.Title>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>SPH</th>
                                            <th>CYL</th>
                                            <th>AXE</th>
                                            <th>ADD</th>
                                            {glass == true && <th>PD</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>OD</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            7,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            7,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            7
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            7,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            7,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            7
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            7,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                7,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    7,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            7
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            7,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            7,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            7
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                7,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                7,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                7
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td>OG</td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            8,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            8,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            8
                                                        )
                                                    }
                                                    name="sph"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            8,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            8,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            8
                                                        )
                                                    }
                                                    name="cyl"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            8,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                8,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    8,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            8
                                                        )
                                                    }
                                                    name="axe"
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            8,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            8,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            8
                                                        )
                                                    }
                                                    name="add"
                                                />
                                            </td>
                                            {glass == true && (
                                                <td>
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                8,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                8,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                8
                                                            )
                                                        }
                                                        name="pd"
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    </tbody>
                                </Table>
                                {error?.reco_opticien && (
                                    <Alert variant={'danger'}>
                                        {t(error?.reco_opticien)}
                                    </Alert>
                                )}
                            </Card.Body>
                        </Card>
                    </>
                )}

                {shouldShow && addEyeTestConfig?.testDetails.length > 8 ? (
                    <Card
                        className={`mb-3 eye_test_symtoms ${user?.userType !== 'EYEDOCTOR'
                            ? 'overflow-auto'
                            : ''
                            }`}
                        style={
                            user?.userType !== 'EYEDOCTOR'
                                ? { maxHeight: '400px' }
                                : {}
                        }
                    >
                        <Card.Body className="modal_form">
                            <Card.Title className="add_eye_title">
                                <Stack
                                    direction="horizontal"
                                    gap={3}
                                    className="mb-3"
                                >
                                    <h4 className="">Ordonnance finale*</h4>
                                </Stack>
                            </Card.Title>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>SPH</th>
                                        <th>CYL</th>
                                        <th>AXE</th>
                                        <th>ADD</th>
                                        {glass == true && <th>PD</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>OD</td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            9,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            9,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            9
                                                        )
                                                    }
                                                    name="sph"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(9, 'sph')}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            9,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            9,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            9
                                                        )
                                                    }
                                                    name="cyl"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(9, 'cyl')}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            9,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                9,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    9,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            9
                                                        )
                                                    }
                                                    name="axe"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(9, 'axe') ==
                                                        '0.00'
                                                        ? '0'
                                                        : selectValue(9, 'axe')}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            9,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            9,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            9
                                                        )
                                                    }
                                                    name="add"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(9, 'add')}
                                                </div>
                                            )}
                                        </td>
                                        {glass == true && (
                                            <td>
                                                {user?.userType ===
                                                    'EYEDOCTOR' ? (
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                9,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                9,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                9
                                                            )
                                                        }
                                                        name="pd"
                                                        isDisabled={!canEdit}
                                                    />
                                                ) : (
                                                    <div className="form-control-plaintext">
                                                        {selectValue(9, 'pd')}
                                                    </div>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>OG</td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={SPH}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            10,
                                                            'sph'
                                                        ),
                                                        label: selectValue(
                                                            10,
                                                            'sph'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            10
                                                        )
                                                    }
                                                    name="sph"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(10, 'sph')}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={CYL}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            10,
                                                            'cyl'
                                                        ),
                                                        label: selectValue(
                                                            10,
                                                            'cyl'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            10
                                                        )
                                                    }
                                                    name="cyl"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(10, 'cyl')}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={AXE}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            10,
                                                            'axe'
                                                        ),
                                                        label:
                                                            selectValue(
                                                                10,
                                                                'axe'
                                                            ) == '0.00'
                                                                ? '0'
                                                                : selectValue(
                                                                    10,
                                                                    'axe'
                                                                ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            10
                                                        )
                                                    }
                                                    name="axe"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(10, 'axe') ==
                                                        '0.00'
                                                        ? '0'
                                                        : selectValue(
                                                            10,
                                                            'axe'
                                                        )}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {user?.userType === 'EYEDOCTOR' ? (
                                                <Select
                                                    components={{
                                                        MenuList:
                                                            CustomMenuList,
                                                    }}
                                                    menuPosition="fixed"
                                                    options={ADD}
                                                    noOptionsMessage={() =>
                                                        t('noOptionMessage')
                                                    }
                                                    className="details_select"
                                                    value={{
                                                        value: selectValue(
                                                            10,
                                                            'add'
                                                        ),
                                                        label: selectValue(
                                                            10,
                                                            'add'
                                                        ),
                                                    }}
                                                    onChange={(
                                                        { value },
                                                        { name }
                                                    ) =>
                                                        changeOption(
                                                            value,
                                                            name,
                                                            10
                                                        )
                                                    }
                                                    name="add"
                                                    isDisabled={!canEdit}
                                                />
                                            ) : (
                                                <div className="form-control-plaintext">
                                                    {selectValue(10, 'add')}
                                                </div>
                                            )}
                                        </td>
                                        {glass == true && (
                                            <td>
                                                {user?.userType ===
                                                    'EYEDOCTOR' ? (
                                                    <Select
                                                        components={{
                                                            MenuList:
                                                                CustomMenuList,
                                                        }}
                                                        menuPosition="fixed"
                                                        options={PD}
                                                        noOptionsMessage={() =>
                                                            t('noOptionMessage')
                                                        }
                                                        className="details_select"
                                                        value={{
                                                            value: selectValue(
                                                                10,
                                                                'pd'
                                                            ),
                                                            label: selectValue(
                                                                10,
                                                                'pd'
                                                            ),
                                                        }}
                                                        onChange={(
                                                            { value },
                                                            { name }
                                                        ) =>
                                                            changeOption(
                                                                value,
                                                                name,
                                                                10
                                                            )
                                                        }
                                                        name="pd"
                                                        isDisabled={!canEdit}
                                                    />
                                                ) : (
                                                    <div className="form-control-plaintext">
                                                        {selectValue(10, 'pd')}
                                                    </div>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                ) : (
                    ''
                )}

                {user?.userType !== 'PATIENT' ? (
                    <Card
                        className={`${view == 'view' ? 'custom_disabled mb-3' : 'mb-3'}`}
                    >
                        <Card.Body>
                            <Card.Title className="add_eye_title">
                                <h4 className="mb-3">{t('acuityDetails')}</h4>
                            </Card.Title>
                            <Row>
                                <Col md={6}>
                                    <Card className="">
                                        <Card.Body className="modal_form">
                                            <Card.Title>OD</Card.Title>
                                            <Form.Group
                                                className={`mb-3 ${error?.info_Acuity_Near_Vision_Right_Eye
                                                    ? 'error_input'
                                                    : ''
                                                    }`}
                                            >
                                                <Form.Label>
                                                    {t('nearVisualAcuity')}*
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Acuity_Near_Vision_Right_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Acuity_Near_Vision_Right_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                                {error?.info_Acuity_Near_Vision_Right_Eye && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t('mustEnterValue')}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                            <Form.Group
                                                className={`mb-3 ${error?.info_Acuity_Distance_Vision_Right_Eye
                                                    ? 'error_input'
                                                    : ''
                                                    }`}
                                            >
                                                <Form.Label>
                                                    {t('distanceVisualAcuity')}*
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Acuity_Distance_Vision_Right_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Acuity_Distance_Vision_Right_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                                {error?.info_Acuity_Distance_Vision_Right_Eye && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t('mustEnterValue')}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t(
                                                        'visualAcuityWithoutDistanceCorrection'
                                                    )}{' '}
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Acuity_visual_sans_correction_Right_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Acuity_visual_sans_correction_Right_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('intraocularPressure')}
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Eye_Pressure_Right_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Eye_Pressure_Right_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col md={6}>
                                    <Card className="">
                                        <Card.Body className="modal_form">
                                            <Card.Title>OG</Card.Title>
                                            <Form.Group
                                                className={`mb-3 ${error?.info_Acuity_Near_Vision_Left_Eye
                                                    ? 'error_input'
                                                    : ''
                                                    }`}
                                            >
                                                <Form.Label>
                                                    {t('nearVisualAcuity')}*
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Acuity_Near_Vision_Left_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Acuity_Near_Vision_Left_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                                {error?.info_Acuity_Near_Vision_Left_Eye && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t('mustEnterValue')}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                            <Form.Group
                                                className={`mb-3 ${error?.info_Acuity_Distance_Vision_Left_Eye
                                                    ? 'error_input'
                                                    : ''
                                                    }`}
                                            >
                                                <Form.Label>
                                                    {t('distanceVisualAcuity')}*
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Acuity_Distance_Vision_Left_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Acuity_Distance_Vision_Left_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                                {error?.info_Acuity_Distance_Vision_Left_Eye && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {t('mustEnterValue')}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t(
                                                        'visualAcuityWithoutDistanceCorrection'
                                                    )}{' '}
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Acuity_visual_sans_correction_Left_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Acuity_visual_sans_correction_Left_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('intraocularPressure')}
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="info_Eye_Pressure_Left_Eye"
                                                        value={
                                                            addEyeTestConfig.info_Eye_Pressure_Left_Eye
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                ) : (
                    ''
                )}
            </div>
            <div>
                {eyeTestImages.eyeTestImagePath2 ||
                    eyeTestImages.eyeTestImagePath3 ||
                    view === 'add' ||
                    view === 'edit' ? (
                    <Card className="mb-3">
                        <Card.Body>
                            <Card.Title className="add_eye_title mb-4">
                                <h4 className="mb-3">{t('imagesTitle')}</h4>
                            </Card.Title>
                            <Row>
                                {/* OD Image Upload */}
                                <Col md={6} className="mb-3">
                                    <Card className="add_eye_upload">
                                        <Card.Title>OD</Card.Title>
                                        <Card.Body>
                                            <Stack gap={3}>
                                                {eyeTestImages.eyeTestImagePath2 ? (
                                                    <>
                                                        <a
                                                            href={`${config.img_URL}/${eyeTestImages.eyeTestImagePath2}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <Image
                                                                src={
                                                                    eyeTestImages.eyeTestImagePath2
                                                                        ? `${config.img_URL}/${eyeTestImages.eyeTestImagePath2}`
                                                                        : images.image2_preview ||
                                                                        EyeUpload
                                                                }
                                                            />
                                                        </a>
                                                    </>
                                                ) : (
                                                    <Image
                                                        src={
                                                            images.image2_preview
                                                                ? images.image2_preview
                                                                : EyeUpload
                                                        }
                                                    />
                                                )}

                                                {(view === 'add' ||
                                                    view === 'edit') && (
                                                        <Form.Control
                                                            type="file"
                                                            name="image2"
                                                            onChange={imageHandle}
                                                        />
                                                    )}
                                            </Stack>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* OG Image Upload */}
                                <Col md={6} className="mb-3">
                                    <Card className="add_eye_upload">
                                        <Card.Title>OG</Card.Title>
                                        <Card.Body>
                                            <Stack gap={3}>
                                                {eyeTestImages.eyeTestImagePath3 ? (
                                                    <>
                                                        <a
                                                            href={`${config.img_URL}/${eyeTestImages.eyeTestImagePath3}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <Image
                                                                src={
                                                                    eyeTestImages.eyeTestImagePath3
                                                                        ? `${config.img_URL}/${eyeTestImages.eyeTestImagePath3}`
                                                                        : images.image3_preview ||
                                                                        EyeUpload
                                                                }
                                                            />
                                                        </a>
                                                    </>
                                                ) : (
                                                    <Image
                                                        src={
                                                            images.image3_preview
                                                                ? images.image3_preview
                                                                : EyeUpload
                                                        }
                                                    />
                                                )}

                                                {(view === 'add' ||
                                                    view === 'edit') && (
                                                        <Form.Control
                                                            type="file"
                                                            name="image3"
                                                            onChange={imageHandle}
                                                        />
                                                    )}
                                            </Stack>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                ) : null}
            </div>
            <div>

                {user.isExternal !== true && user?.userType === 'OPTICIAN' ? (
                    <Col md={12}>
                        <Card className="w-100">
                            <Card.Body className="modal_form">
                                <Card.Title>
                                    {t('resultExamineTitle')}*
                                </Card.Title>

                                <Form.Group
                                    className={`${error?.resultExamine ? 'error_input' : ''}`}
                                >
                                    {view === 'view' ? (
                                        <Form.Control
                                            type="text"
                                            value={
                                                addEyeTestConfig?.infoResultExamine || 'N/A'
                                            }
                                            readOnly
                                        />
                                    ) : (
                                        <Form.Select
                                            value={
                                                addEyeTestConfig?.resultExamine ||
                                                addEyeTestConfig?.infoResultExamine ||
                                                ''
                                            }
                                            name="resultExamine"
                                            onChange={handleChange}
                                            aria-label="Default select example"
                                            required
                                        >
                                            <option disabled value="">
                                                {t('selectItem')}
                                            </option>

                                            <option value="Devis">
                                                {t('devis')}
                                            </option>

                                            <option value="Juste ordonnance">
                                                {t('justeOrdonnance')}
                                            </option>

                                            <option value="Vente">
                                                {t('vente')}
                                            </option>

                                            <option value="Retour ophtalmologue">
                                                {t('retourOphtalmologue')}
                                            </option>

                                            <option value="Sans ordonnance">
                                                {t('sansOrdonnance')}
                                            </option>
                                        </Form.Select>
                                    )}

                                    {error?.resultExamine && (
                                        <Form.Control.Feedback type="invalid">
                                            {t('mustEnterValue')}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                ) : null}
            </div>
        </>
    );
};
export default Step3;
